/* global $ */

import { bb } from "$json";

const props = bb.propFinder(bb.conf, "arbitrary.previews");

function fixPreviews(data) {
  if (data && data.documents) {
    const group = data.groups.find(group => group.current);
    const setting = props(`only.${data.modelname}.${group.name}`);
    if (!setting) data.documents = [];
    // else (e.g. if true) leave intact
  }
}

$(document).on("bb:preHandleData", (_, data) => fixPreviews(data));
